/*
 * Copyright (c) 2022. World Wide Generation Ltd
 */

import React from 'react';
import { DelegationRoles } from '@constants/user';
import { ColumnCommonProps } from '@g17eco/types/survey-question-list';
import { getUserNameList } from '@features/survey-question-list/utils';
import { Column } from '@g17eco/molecules/tracking-list';
import { SurveyDelegationUser } from '@g17eco/types/user';

interface ColumnVerifiersProps extends ColumnCommonProps{
  users?: SurveyDelegationUser[];
}


export const ColumnVerifiers = (props: ColumnVerifiersProps) => {
  const { question, handleGoToQuestion, users = [] } = props;

  const userList = getUserNameList({
    users,
    delegationUserIds: question.utrv?.stakeholders.verifier,
    // Only show users with inititiave role, as other must be based on utrv
    check: (u) => u.delegationRoles.includes(DelegationRoles.InitiativeVerifier),
  });

  return (
    <Column className='pl-2 stakeholderCol' truncateTwoline onClick={handleGoToQuestion}>
      <strong>Verifiers:</strong> {userList.join(', ') || 'none'}
    </Column>
  );
}
